import { Box, Button, Tooltip } from "@mui/material";
import InvoiceReceiptLongOffIconRed from '../../../../src/img/receipt_long_off_red.svg';
import InvoiceReceiptLongOffIcon from '../../../../src/img/receipt_long_off.svg';
import CancelModal from "../../list/CancelModal";
import { useState } from "react";
import ErrorAlertSnackbar from "../../../../components/shared/snackbars/ErrorAlertSnackbar";
import SuccessAlertSnackbar from "../../../../components/shared/snackbars/SuccessAlertSnackbar";

const InvoiceShowCancel = ({ invoice, setLoadingInstallmentsTable, loadingInstallmentsTable }) => {
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);

    const handleOpenCancelModal = () => setOpenCancelModal(true);
    const handleCloseCancelModal = () => setOpenCancelModal(false);
    const handleCancelResult = async (isError) => {
        if (isError) {
            setErrorSnackbarOpen(true);
        } else {
            setSuccessSnackbarOpen(true);
            setLoadingInstallmentsTable(true);
        }
    };

    const canCancelInvoice = invoice?.status === "pending" || invoice?.status === "overdue";
    return (
        <>
            {invoice && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip
                        title={!canCancelInvoice ? "O status dessa fatura não permite cancelamento" : ""}
                        arrow
                    >
                        <span>
                            <Button
                                variant="redOutlined"
                                startIcon={!canCancelInvoice ?  <img src={InvoiceReceiptLongOffIcon} /> : <img src={InvoiceReceiptLongOffIconRed} />}
                                onClick={handleOpenCancelModal}
                                sx={{ mr: 1 }}
                                disabled={!canCancelInvoice || loadingInstallmentsTable}
                            >
                                Cancelar fatura
                            </Button>
                        </span>
                    </Tooltip>
                    <CancelModal
                        open={openCancelModal}
                        onClose={handleCloseCancelModal}
                        invoiceId={invoice.id}
                        onErrorChange={handleCancelResult}
                    />
                    <ErrorAlertSnackbar
                        open={errorSnackbarOpen}
                        onClose={() => setErrorSnackbarOpen(false)}
                        message="Não foi possível realizar a ação. Tente novamente."
                        vertical="bottom"
                        horizontal="center"
                    />
                    <SuccessAlertSnackbar
                        open={successSnackbarOpen}
                        onClose={() => setSuccessSnackbarOpen(false)}
                        message="Fatura cancelada com sucesso"
                        vertical="bottom"
                        horizontal="center"
                    />
                </Box>
            )}
        </>
    )
}

export default InvoiceShowCancel;